import React, { useState, useEffect } from 'react';
import Modal from '../features/keywords/react/Modal/Modal';
import styles from '../features/keywords/react/Modal/Modal.module.scss';

export default function ConfirmModal({ message, onConfirm, onCancel, onClose }) {
  const [Shown, SetShown] = useState(false);

  useEffect(() => {
    SetShown(true);
  }, []);

  const close = callback => {
    SetShown(false);
    onClose();
    if (callback) setTimeout(callback, 250);
  }

  const handleConfirm = () => {
    close(onConfirm);
  };
  
  const handleCancel = () => {
    close(onCancel);
  };

  return (
    <Modal show={Shown} dismissable={true} showClose={false} onClose={handleCancel}>
      <div style={{padding: '48px 52px 42px', maxWidth: '600px'}}>
        <div style={{display: 'flex', gap: '20px', alignItems: 'flex-start', marginBottom: '30px'}}>
          <i className="fa-solid fa-circle-question" style={{fontSize: '24px', color: '#F5A623', marginTop: '2px', flexShrink: 0}}></i>
          <p className={styles.message} style={{margin: 0, fontSize: '16px', lineHeight: '1.6', flex: 1}}>{message}</p>
        </div>
        <div style={{display: 'flex', gap: '12px', justifyContent: 'center'}}>
          <button className='standard' onClick={handleCancel} style={{minWidth: '120px'}}>Cancel</button>
          <button className='accented-standard' onClick={handleConfirm} style={{minWidth: '120px'}}>OK</button>
        </div>
      </div>
    </Modal>
  );
}
